module.exports = __webpack_public_path__ + "img/Last image OOBE English.f8a6eb9e.png";